import { getAllCategoryIds, legacyCategoryAliases } from './categories.js';
// ---------------------------------------------------------------------------
// Ограничения и валидация, общие для клиента, Worker и publisher
// ---------------------------------------------------------------------------
export const MAX_SUBMIT_PHOTOS = 5;
export const MAX_PHOTO_DATA_URL_BYTES = 3 * 1024 * 1024;
export const MAX_SUBMIT_BODY_BYTES = 25 * 1024 * 1024;
export const MAX_WANTED_LENGTH = 200;
export const MAX_MAKE_LENGTH = 40;
export const MAX_MODEL_LENGTH = 60;
const DATA_URL_RE = /^data:(image\/(?:jpeg|png|webp));base64,/;
/** Поточні id + легасі id (старі клієнти ще можуть слати id до 11-категорійної таксономії). */
export function isKnownCategoryId(id) {
    return getAllCategoryIds().includes(id) || id in legacyCategoryAliases;
}
export function isDataUrl(value) {
    return DATA_URL_RE.test(value);
}
export function dataUrlBytes(value) {
    const base64 = value.slice(value.indexOf(',') + 1);
    return Math.floor((base64.length * 3) / 4);
}
export function photoExtensionFromMime(mime) {
    if (mime === 'image/webp')
        return 'webp';
    if (mime === 'image/png')
        return 'png';
    return 'jpg';
}
export function validateAdSubmissionInput(data) {
    const errors = [];
    if (!data.title || data.title.trim().length < 3) {
        errors.push('title is required (min 3 chars)');
    }
    if (data.title && data.title.length > 200) {
        errors.push('title too long (max 200 chars)');
    }
    if (!data.description || data.description.trim().length < 10) {
        errors.push('description is required (min 10 chars)');
    }
    if (data.description && data.description.length > 5000) {
        errors.push('description too long (max 5000 chars)');
    }
    if (data.price !== undefined && data.price !== null && data.price < 0) {
        errors.push('price cannot be negative');
    }
    if (data.categoryId && !isKnownCategoryId(data.categoryId)) {
        errors.push('invalid categoryId');
    }
    if (data.condition !== undefined && data.condition !== 'new' && data.condition !== 'used') {
        errors.push('invalid condition (must be "new" or "used")');
    }
    if (data.wanted !== undefined && data.wanted !== null && data.wanted.length > MAX_WANTED_LENGTH) {
        errors.push(`wanted too long (max ${MAX_WANTED_LENGTH})`);
    }
    if (data.make !== undefined && data.make !== null && data.make.length > MAX_MAKE_LENGTH) {
        errors.push(`make too long (max ${MAX_MAKE_LENGTH})`);
    }
    if (data.model !== undefined && data.model !== null && data.model.length > MAX_MODEL_LENGTH) {
        errors.push(`model too long (max ${MAX_MODEL_LENGTH})`);
    }
    if (data.photos && data.photos.length > MAX_SUBMIT_PHOTOS) {
        errors.push(`max ${MAX_SUBMIT_PHOTOS} photos allowed`);
    }
    if (!data.contacts) {
        errors.push('contacts is required');
    }
    else if (!data.contacts.preferred) {
        errors.push('contacts.preferred is required');
    }
    return errors;
}
/** Лёгкая проверка формы сабмита на входе Worker (полная валидация — в publisher). */
export function validateSubmissionShape(kind, payload) {
    const errors = [];
    const p = (payload ?? {});
    if (!p.adId || typeof p.adId !== 'string') {
        errors.push('adId is required');
        return errors;
    }
    switch (kind) {
        case 'create':
            return validateAdSubmissionInput(p);
        case 'update': {
            const u = p;
            if (u.photos !== undefined && u.photos.length > MAX_SUBMIT_PHOTOS) {
                errors.push(`max ${MAX_SUBMIT_PHOTOS} photos allowed`);
            }
            if (u.renew !== undefined && typeof u.renew !== 'boolean') {
                errors.push('renew must be boolean');
            }
            if (u.categoryId !== undefined && !isKnownCategoryId(u.categoryId)) {
                errors.push('invalid categoryId');
            }
            if (u.condition !== undefined &&
                u.condition !== null &&
                u.condition !== 'new' &&
                u.condition !== 'used') {
                errors.push('invalid condition (must be "new" or "used")');
            }
            if (typeof u.wanted === 'string' && u.wanted.length > MAX_WANTED_LENGTH) {
                errors.push(`wanted too long (max ${MAX_WANTED_LENGTH})`);
            }
            if (typeof u.make === 'string' && u.make.length > MAX_MAKE_LENGTH) {
                errors.push(`make too long (max ${MAX_MAKE_LENGTH})`);
            }
            if (typeof u.model === 'string' && u.model.length > MAX_MODEL_LENGTH) {
                errors.push(`model too long (max ${MAX_MODEL_LENGTH})`);
            }
            break;
        }
        case 'delete':
            break;
        case 'statusChange': {
            const s = p.status;
            if (s !== 'active' && s !== 'sold' && s !== 'archived') {
                errors.push('invalid status');
            }
            break;
        }
        case 'report': {
            const r = p.reason;
            if (!r || typeof r !== 'string' || r.length > 200) {
                errors.push('reason is required (max 200 chars)');
            }
            break;
        }
        case 'view':
            break;
    }
    return errors;
}
//# sourceMappingURL=submissions.js.map